import axios from 'axios';

const BASE = process.env.REACT_APP_API_URL || 'http://localhost:5050';
export const ADMIN_PATH = process.env.REACT_APP_ADMIN_PATH || 'backoffice';

const client = axios.create({ baseURL: BASE });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

client.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('admin_token');
      window.location.href = `/${ADMIN_PATH}`;
    }
    return Promise.reject(err);
  }
);

export const adminApi = {
  login: (username: string, password: string) =>
    client.post<{ success: boolean; token: string }>('/admin/auth/login', { username, password }),

  getStats: () => client.get('/admin/stats'),
  getFlaggedPins: () => client.get('/admin/flagged-pins'),
  deletePin: (id: string) => client.delete(`/admin/pins/${id}`),
  unflagPin: (id: string) => client.patch(`/admin/pins/${id}/unflag`),

  getTopIps: () => client.get('/admin/ips'),
  getBlockedIps: () => client.get('/admin/ips/blocked'),
  blockIp: (ip_address: string, reason: string, expires_at?: string) =>
    client.post('/admin/ips/block', { ip_address, reason, expires_at }),
  unblockIp: (ip: string) => client.delete(`/admin/ips/block/${encodeURIComponent(ip)}`),
  getIpActivity: (ip: string) =>
    client.get(`/admin/ips/${encodeURIComponent(ip)}/activity`),

  getErrors: (type?: string, limit?: number, skip?: number) =>
    client.get('/admin/errors', { params: { type, limit, skip } }),

  getRoomMatches: () => client.get('/admin/room-matches'),

  getAllSeekers: (params: { city?: string; searchType?: string; skip?: number; limit?: number }) =>
    client.get('/admin/seekers', { params }),

  getAllPosters: (params: { city?: string; listingType?: string; skip?: number; limit?: number }) =>
    client.get('/admin/posters', { params }),

  getAllPins: (params: {
    city?: string; bedrooms?: number | ''; minRent?: number | ''; maxRent?: number | '';
    propertyType?: string; furnishing?: string; flagged?: string;
    skip?: number; limit?: number; sort?: string;
  }) => client.get('/admin/pins', { params }),
};
